import { createFileRoute } from '@tanstack/react-router'
import LogsPage from '@/pages/dashboard/logs-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/logs',
)({
  component: function LogsRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.VIEW_AUDIT}>
        <LogsPage />
      </ProtectedRoute>
    )
  },
})
